import { Pipe, PipeTransform } from '@angular/core';
import { OBTRailJourneyOption } from '@sabstravtech/obtservices/base';

import { classSelectors } from '../../modal/cheapest-fare-finder-modal/cheapest-fare-finder-modal..component';

@Pipe({
  name: 'cheapestFareFinderInbounds',
  standalone: false
})
export class CheapestFareFinderInboundsPipe implements PipeTransform {
  transform(
    journeys: OBTRailJourneyOption[],
    resultMatrix: any,
    classSelector: classSelectors
  ): any {
    if (journeys && resultMatrix && classSelector) {
      return journeys.filter((journey) =>
        this.checkInbounds(resultMatrix, journey.journeyHash, classSelector)
      );
    } else {
      return [];
    }
  }

  checkInbounds(resultMatrix: any, journeyHash: string, classSelector: classSelectors) {
    const hasOneAvailableValue = !!Object.keys(resultMatrix).find((key) => {
      if (
        resultMatrix[key]?.[journeyHash]?.[classSelector]?.out &&
        resultMatrix[key]?.[journeyHash]?.[classSelector]?.in
      ) {
        return true;
      } else {
        return false;
      }
    });
    return hasOneAvailableValue;
  }
}
